module.exports = __webpack_public_path__ + "static/media/2004.c80be92b.png";